<template>
  <v-card :loading="loading" :disabled="loading">
    <v-toolbar flat>
      <v-icon left color="accent">mdi-golf-cart</v-icon>
      <v-toolbar-title>Irons</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        class="mr-2"
        @click="openSingleForm()"
        :disabled="!isModifiable"
      >
        <v-icon>mdi-plus</v-icon>Add Single Iron
      </v-btn>
      <v-btn
        outlined
        @click="formType = 'set';formSetEdit = true;"
        :disabled="!isModifiable"
      >
        <v-icon>mdi-plus</v-icon>Add Iron Set
      </v-btn>
    </v-toolbar>
    <PrescriptionItems
      :headers="headers"
      :items="items"
      :isModifiable="isModifiable"
      @update="update()"
      @edit="(item) => openSingleForm(item)"
    />
    <iron-form
      ref="ironForm"
      :prescriptionId="prescriptionId"
      :dominantHand="dominantHand"
      :catalogId="this.catalogId"
      :currency="prescription.currency.currency"
      @update="update()"
    ></iron-form>
    <iron-set-form
      :item="itemToEdit"
      :open="formSetEdit"
      :prescriptionId="prescriptionId"
      :dominantHand="dominantHand"
      :shopId="this.shopId"
      :catalogId="this.catalogId"
      :type="this.formType"
      v-on:update="update()"
      @add="() => {formSetEdit=false; update()}"
      @cancel="() => {formSetEdit=false}"
    ></iron-set-form>
  </v-card>
</template>

<script>
import IronForm from "./IronForm";
import IronSetForm from "./IronSetForm";
import PrescriptionItems from './PrescriptionItems.vue';

export default {
  components: {
    IronForm,
    IronSetForm,
    PrescriptionItems
},
  props: ["irons", "prescriptionId", "dominantHand", "shopId", 'catalogId', "prescription"],
  data: function() {
    return {
      items: this.irons,
      itemToEdit: null,
      formEdit: false,
      formSetEdit: false,
      formType: "solo",
      headers: [
        { text: "Quote", value: "quote", sortable: false },
        { text: "Quantity", value: "quantity" },
        { text: "SST Pure", value: "sst", sortable: false },
        { text: "Stamping", value: "stamping", sortable: false },
        { text: "Paintfill", value: "paintfill", sortable: false },
        { text: "Head", value: "head" },
        { text: "Shaft", value: "shaft" },
        { text: "Grip", value: "grip" },
        { text: "Actions", value: "actions"},
      ],
      loading: false
    };
  },
  computed : {
    isModifiable () {
      return this.prescription.isModifiable
    }
  },
  methods: {
    getList() {
      this.loading = true
      this.$store
        .dispatch("prescriptionIron/get", {
          id: this.prescriptionId
        })
        .then(datas => (this.items = datas))
        .finally(() => {this.loading = false});
    },
    update() {
      this.getList();
      this.$emit("update");
    },
    addItem() {
      this.update();
    },
    openSingleForm(item) {
      this.$refs.ironForm.open(item)
    }
  }
};
</script>

<style></style>
